<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">关于我们</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="8" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "关于我们-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            content: '',
        };
    },
    created() {
        this.getAgreement();
    },
    methods: {
        getAgreement() {
            this.$api.getAgreement({ id: 3 }).then(res => {
                if (res.code == 1) {
                    this.content = res.data.content;
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    background: #fff;
    padding: 30px 44px;

    .title_box {
        height: 110px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        color: #a0c8ff;
        margin-bottom: 30px;
    }

    .detail {
        margin-bottom: 70px;
    }
}
</style>
